import React, { useState, useEffect } from 'react';
import '../../css/Pages.css';
import RewardTypeListing from '../../components/CategoryManagement/RewardType/RewardTypeListing';
import RewardTypeForm from '../../components/CategoryManagement/RewardType/RewardTypeForm';
import { useConfirmDeleteDialog } from '../../hooks/useConfirmDeleteDialog';
import { useCloseConfirmDialog } from '../../hooks/useCloseConfirmDialog';

const RewardType = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newName, setNewName] = useState('');
    const [editId, setEditId] = useState(null);

    const [isDesktop, setIsDesktop] = useState(true);

    const { confirmDeleteDialog } = useConfirmDeleteDialog();
    const { confirmCloseDialog } = useCloseConfirmDialog();

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${API_BASE_URL}/rewardtype`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 401 || response.status === 403) {
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
                return;
            }

            if (response.ok) {
                const result = await response.json();
                if (Array.isArray(result)) {
                    setData(result);
                    setFilteredData(result);
                } else {
                    console.error("Lỗi: Dữ liệu API trả về không phải là mảng", result);
                    setData([]);
                    setFilteredData([]);
                }
            } else {
                console.error("Lỗi HTTP:", response.status);
                setData([]);
                setFilteredData([]);
            }
        } catch (error) {
            console.error("Lỗi tải dữ liệu:", error);
            setData([]);
            setFilteredData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        setFilteredData(data.filter(item => item.Name.toLowerCase().includes(query)));
    };

    const handleEdit = (item) => {
        setEditId(item.Id);
        setNewName(item.Name);
        setIsModalOpen(true);
    };

    const handleDelete = (id) => {
        confirmDeleteDialog({
            header: 'Xác nhận xóa',
            message: 'Bạn có chắc chắn muốn xóa loại khen thưởng này không?',
            accept: async () => {
                try {
                    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
                    const response = await fetch(`${API_BASE_URL}/rewardtype?id=${id}`, {
                        method: 'DELETE',
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });

                    if (response.status === 401 || response.status === 403) {
                        localStorage.removeItem('user');
                        localStorage.removeItem('accessToken');
                        window.location.href = '/login';
                        return;
                    }

                    if (response.ok) {
                        const newData = data.filter(item => item.Id !== id);
                        setData(newData);
                        setFilteredData(newData.filter(item => item.Name.toLowerCase().includes(searchQuery)));
                    } else {
                        alert("Xóa thất bại! Vui lòng kiểm tra quyền.");
                    }
                } catch (error) {
                    console.error("Lỗi xóa:", error);
                }
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newName.trim() === '') {
            alert("Vui lòng nhập tên loại khen thưởng!");
            return;
        }

        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const method = editId ? 'PUT' : 'POST';
            const body = editId ? { Id: editId, Name: newName } : { Name: newName };

            const response = await fetch(`${API_BASE_URL}/rewardtype`, {
                method,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            if (response.status === 401 || response.status === 403) {
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
                return;
            }

            if (response.ok) {
                fetchData();
                closeModal();
            } else {
                alert("Lưu thất bại! Vui lòng kiểm tra lại quyền.");
            }
        } catch (error) {
            console.error("Lỗi lưu dữ liệu:", error);
        }
    };

    const closeModal = () => { setIsModalOpen(false); setNewName(''); setEditId(null); };

    return (
        <div className="page-container">
            <div
                className="page-header"
                style={isDesktop ? { marginBottom: '10px' } : { marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}
            >
                <div className="header-title">
                    <h2 style={isDesktop ? {} : { margin: 0 }}>DANH MỤC LOẠI KHEN THƯỞNG</h2>
                </div>
                <button
                    className="btn-add-new"
                    onClick={() => { setEditId(null); setNewName(''); setIsModalOpen(true); }}
                    style={isDesktop ? {} : { width: '100%', margin: 0 }}
                >
                    <i className="fa-solid fa-plus"></i> Thêm mới
                </button>
            </div>

            <div style={isDesktop
                ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', marginTop: '10px' }
                : { display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px', marginTop: '10px' }
            }>
                <p className="sub-title" style={{ margin: 0 }}>
                    DANH SÁCH LOẠI KHEN THƯỞNG
                </p>

                <div style={isDesktop
                    ? { display: 'flex', gap: '10px' }
                    : { display: 'flex', gap: '10px', width: '100%', alignItems: 'stretch' }
                }>
                    <div style={isDesktop ? { position: 'relative' } : { position: 'relative', flex: 1 }}>
                        <i className="fa-solid fa-magnifying-glass" style={{ position: 'absolute', left: '12px', top: '12px', color: '#888' }}></i>
                        <input
                            type="text"
                            placeholder="Tra cứu loại khen thưởng"
                            className="form-input"
                            style={isDesktop
                                ? { width: '300px', padding: '10px 15px 10px 35px', borderRadius: '6px', border: '1px solid #ccc' }
                                : { width: '100%', padding: '10px 15px 10px 35px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box', height: '100%' }
                            }
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>
                    <button
                        onClick={fetchData}
                        className="btn-add-new"
                        style={isDesktop
                            ? { margin: 0, padding: '10px 15px', backgroundColor: '#6c757d' }
                            : { margin: 0, padding: '0', width: '45px', flex: '0 0 45px', backgroundColor: '#6c757d', display: 'flex', justifyContent: 'center', alignItems: 'center' }
                        }
                        title="Tải lại dữ liệu"
                    >
                        <i className="fa-solid fa-rotate-right"></i>
                    </button>
                </div>
            </div>

            <RewardTypeListing
                data={filteredData}
                onEdit={handleEdit}
                onDelete={handleDelete}
                isLoading={isLoading}
                searchQuery={searchQuery}
            />

            <RewardTypeForm
                isOpen={isModalOpen}
                onClose={() => (newName.trim() !== '' ? confirmCloseDialog(closeModal) : closeModal())}
                onSubmit={handleSubmit}
                newName={newName}
                setNewName={setNewName}
                isEditing={!!editId}
            />
        </div>
    );
};

export default RewardType;